module.exports = __webpack_public_path__ + "static/media/nft-4.95ec6229.png";